import DataRoomDocument from './DataRoomDocument.component';

export default DataRoomDocument;